import React from "react";

import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";

import IbanMobileContent from "components/IbanInvoiceInfo/MobileContent";
import IbanDesktopContent from "components/IbanInvoiceInfo/DesktopContent";

import PageNetBackground from "components/PageNetBackground";
import PageHeading from "components/IbanInvoiceInfo/PageHeading";

import { IbanInvoiceResponseDto } from "api";

import { styles } from "./styles";

interface IbanInfoPreviewProps {
  iban: IbanInvoiceResponseDto | null;
  isMobile: boolean;
}

const IbanInfoPreview: React.FC<IbanInfoPreviewProps> = (props) => {
  const { iban, isMobile } = props;

  return isMobile ? (
    <Box sx={styles.mobileWrapper}>
      <PageNetBackground>
        <Stack direction="column" sx={{ p: 2, pb: 10, gap: 1 }}>
          <IbanMobileContent iban={iban} />
        </Stack>
      </PageNetBackground>
    </Box>
  ) : (
    <Stack direction="column" sx={{ pt: 2, pb: 10, gap: 1 }}>
      <PageHeading isPreview />
      <Stack sx={styles.previewContent}>
        <IbanDesktopContent iban={iban} />
      </Stack>
    </Stack>
  );
};

export default IbanInfoPreview;
